import { Pipe, PipeTransform } from '@angular/core';
import { PanelLayout } from '@models';

@Pipe({
    name: 'portfolioReportFilter'
})
export class PortfolioReportFilterPipe implements PipeTransform {
    constructor() {}

    transform(panelLayouts: PanelLayout[]): PanelLayout[] {
        return panelLayouts ? this.sortedPanelLayouts(panelLayouts) : [];
    }

    // Manage what's visible in print
    // ------------------------------
    // Exclusion list for panels not to be included in print version
    private excludePanelKeys = [
        'options-panel'
        // Future keys to exclude from print can be added here
    ];

    private sortedPanelLayouts(panelLayouts: PanelLayout[]): PanelLayout[] {
        const panelLayoutsWithoutExcluded = panelLayouts.filter(
            (panelLayout) => !this.isPanelExcluded(panelLayout.panelId)
        );

        const panelOrder = [
            'portfolio-report-search',
            'portfolio-report-performance-chart',
            'portfolio-report-pnl-result-tables',
            'portfolio-report-stocks',
            'portfolio-report-fixed-income',
            'portfolio-report-funds-and-other-assets',
            'portfolio-report-private-equity',
            'portfolio-report-real-estate',
            'portfolio-report-private-assets',
            'portfolio-report-loans',
            'portfolio-report-corporate-actions',
            'portfolio-report-net-trades'
        ];

        const sortedPanelLayouts = panelLayoutsWithoutExcluded.sort((a, b) => {
            // Find the index of the panelIds in the panelOrder array
            let indexA = panelOrder.indexOf(a.panelId);
            let indexB = panelOrder.indexOf(b.panelId);

            // If a panelId is not found in the panelOrder, set its sort index to a large number to ensure it's sorted at the end
            indexA = indexA === -1 ? Number.MAX_VALUE : indexA;
            indexB = indexB === -1 ? Number.MAX_VALUE : indexB;

            // Compare the indices to determine the order
            if (indexA < indexB) {
                return -1; // a comes first
            } else if (indexA > indexB) {
                return 1; // b comes first
            } else {
                return 0; // a and b are the same
            }
        });

        return sortedPanelLayouts || [];
    }

    // Utility method to check if a panel should be excluded based on its panelId
    private isPanelExcluded(panelId: string): boolean {
        return this.excludePanelKeys.indexOf(panelId) > -1;
    }
    // End of what's visible in print
    // ------------------------------
}
